import { REJECTION_REASONS } from '../constants';

const OUTPUT_STATUS = {
  INTERNAL_REVIEW: 'INTERNAL_REVIEW',
  PENDING_REVIEW: 'PENDING_REVIEW',
  COST_REVIEW: 'COST_REVIEW'
};

const getChangesModalConstants = (status) => {
  if (status === OUTPUT_STATUS.INTERNAL_REVIEW) {
    return {
      title: 'Reject Version',
      subtitle: 'Reason for rejection',
      additionalReasonTitle: 'Additional Comments',
      reasons: REJECTION_REASONS.REJECT_VERSION,
      allowOther: false
    };
  }

  return {
    title: 'Submit Changes',
    subtitle: 'Tell us why',
    additionalReasonTitle: 'Reason',
    reasons: REJECTION_REASONS.SUBMIT_CHANGES,
    allowOther: true
  };
};

export default getChangesModalConstants;